import { component } from 'picoapp';
import { clear } from 'utils/node';

export default component(async (node) => {
  const getFilter = async () => {
    const section = await fetch('/?section_id=filter');
    const originalSection = document.querySelector('#shopify-section-filter');
    originalSection.remove();

    const response = await section.text();
    const html = new DOMParser().parseFromString(response, 'text/html');

    const filters = html.querySelector('[data-filters]');
    return filters.outerHTML;
  };

  const renderFilter = async () => {
    const markup = await getFilter();
    clear(node);
    node.innerHTML = markup;

    document.dispatchEvent(new Event('filters:loaded'));
  };

  renderFilter();
});
